export default "__VITE_ASSET__BQk0GqbJ__"